(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const initPersonalisedFilters = () => {
    const toolbar = document.querySelector('[data-personalised-filters]');
    const grid = document.querySelector('#ResultsList .product-grid');
    if (!toolbar || !grid) return;

    const cards = Array.from(grid.querySelectorAll('.product-grid__item[data-filter-text]'));
    const count = toolbar.querySelector('[data-filter-count]');
    const countLabel = toolbar.dataset.productsShown || '';
    const state = { event: '', product: '' };

    const matchesTerms = (text, value) => {
      if (!value) return true;
      return value.split('|').some((term) => text.includes(term));
    };

    const applyFilters = () => {
      let visible = 0;

      cards.forEach((card) => {
        const text = card.dataset.filterText || '';
        const show = matchesTerms(text, state.event) && matchesTerms(text, state.product);
        card.hidden = !show;
        if (show) visible += 1;
      });

      grid.classList.toggle('personalised-filter-active', Boolean(state.event || state.product));
      if (count) count.textContent = [visible, countLabel].filter(Boolean).join(' ');
    };

    toolbar.querySelectorAll('[data-filter-group]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.dataset.filterGroup;
        state[group] = button.dataset.filterTerms || '';

        toolbar.querySelectorAll('[data-filter-group="' + group + '"]').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        applyFilters();
      });

      button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false');
    });

    applyFilters();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPersonalisedFilters, { once: true });
  } else {
    initPersonalisedFilters();
  }

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
